import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { ExistFileFormat, OptionView } from 'src/app/models/products/products';
import { DynamicOptionResponse } from 'src/app/models/products/transactions';
import { ProductDetailsUiStateService } from '../product-details-ui-state.service';

@Component({
  selector: 'app-product-price-list',
  templateUrl: './product-price-list.component.html',
  styleUrls: ['./product-price-list.component.scss']
})
export class ProductPriceListComponent implements OnInit, AfterViewInit {

  displayPriceListLeft = true;
  displayPriceListRight = false;

  constructor(public pUiService: ProductDetailsUiStateService,) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void{
    const priceListWidth = document.querySelector('.price-list-wrapper').clientWidth;
    const priceTableWidth = document.querySelector('.price-list-wrapper .table').clientWidth;
    if (priceListWidth < priceTableWidth) {
      this.displayPriceListLeft = false;
    }
  }

  scrollPriceListRight(): void {
    document.getElementsByClassName('price-list')[0].scrollLeft = document.getElementsByClassName('price-list')[0].scrollWidth;
  }

  scrollPriceListLeft(): void {
    document.getElementsByClassName('price-list')[0].scrollLeft = 0;
  }

  pricelistScroll(e): void {
    if (e.target.scrollLeft === 0) {
      this.displayPriceListLeft = false;
      this.displayPriceListRight = true;
    } else {
      this.displayPriceListLeft = true;
      this.displayPriceListRight = false;
    }
  }

  filterFormatPrices(items: Array<ExistFileFormat>): number {
    let price = 0;
    let found = false;
    for (let i = 0; i < items.length; i++) {
      if (items[i].Price > 0 && !found) {
        price = items[i].Price;
        found = true;
      }
    }
    return price;
  }

}
